import GuicheForm from "./form";
import { useAttendanceLocalGuicheCreate } from "../../../../../../../services/api-tansquery/attendance-local/guiche/create";

type GuicheFormProps = {
    slug: string;
    buttonTrigger?: React.ReactNode;
};

export default function GuicheFormCreate(props: GuicheFormProps) {
    const mutation = useAttendanceLocalGuicheCreate();

    return (
        <GuicheForm
            {...props}
            mutation={mutation}
        />
    );
}
